// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__J-kbG","errorLogs":"EditorFooter_errorLogs__3tQpz"};